// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NN-z","twoColumnImage":"ON-z"};